import { render } from "./SetPasskeyNameDialog.vue?vue&type=template&id=0cc0dc73"
import script from "./SetPasskeyNameDialog.vue?vue&type=script&lang=js"
export * from "./SetPasskeyNameDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__